// removed by extract-text-webpack-plugin
module.exports = {"ant-table-thead":"ant-table-thead","ant-table-tbody":"ant-table-tbody","ant-table-expanded-row":"ant-table-expanded-row","ant-table-row-selected":"ant-table-row-selected"};